export const breakpoints = {
  xxxl: 1920,
  xxl: 1536,
  xl: 1280,
  lg: 1024,
  md: 768,
  sm: 640,
  xs: 460,
  xxs: 340
};
